import { BasicEnumerable } from "../BasicEnumerable.js";
export const append = (source, element) => {
    function* iterator() {
        yield* source;
        yield element;
    }
    return new BasicEnumerable(iterator);
};
